import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72d4f514"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "my"
}
const _hoisted_2 = { class: "logout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_ctx.userInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_cell_group, {
          title: "基本信息",
          class: "uf-cell"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "头像",
              value: "内容",
              "is-link": "",
              center: "",
              "value-class": "uf-cell-value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_image, {
                  round: "",
                  width: "40px",
                  height: "40px",
                  src: _ctx.userInfo.head_pic || _ctx.defaultAvatar
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_cell, {
              title: "姓名",
              value: _ctx.userInfo.name,
              "is-link": "",
              center: ""
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "性别",
              value: _ctx.filterGender(_ctx.userInfo.gender),
              "is-link": "",
              center: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "账号信息",
          class: "uf-cell"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "手机号",
              value: _ctx.userInfo.mobile,
              "is-link": "",
              center: ""
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "修改密码",
              "is-link": "",
              center: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "当前身份",
          class: "uf-cell"
        }, {
          default: _withCtx(() => [
            (_ctx.userInfo.role_id === '2')
              ? (_openBlock(), _createBlock(_component_van_cell, {
                  key: 0,
                  title: "临时用户",
                  value: _ctx.authenticationState.state_name || '申请认证',
                  "is-link": "",
                  center: "",
                  to: {
          name: ['2', '3'].includes(_ctx.authenticationState.state)
            ? _ctx.$RouterName.AUTHENTICATION_DETAIL
            : _ctx.$RouterName.AUTHENTICATION
        }
                }, null, 8, ["value", "to"]))
              : (_ctx.userInfo.role_id === '3')
                ? (_openBlock(), _createBlock(_component_van_cell, {
                    key: 1,
                    title: "客户",
                    center: ""
                  }))
                : (_ctx.userInfo.role_id === '7')
                  ? (_openBlock(), _createBlock(_component_van_cell, {
                      key: 2,
                      title: "供应商人员",
                      center: ""
                    }))
                  : (_openBlock(), _createBlock(_component_van_cell, {
                      key: 3,
                      title: "内部员工",
                      center: ""
                    }))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_button, {
            color: "#3d6eeb",
            size: "large",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 退出登录")
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}